import {DetailDialog, DetailDialogProps} from "../../../../components/DetailDialog";
import {EQUIPMENT_URLS, URL_PARAMS, DISP_MODE} from "../../../../constants/constants";

export interface ArmDetailDialogProps extends Omit<DetailDialogProps, 'title' | 'src'> {
  armId: string,
}

export function ArmDetailDialog(props: ArmDetailDialogProps) {
  // console.log('Arm Detail Dialog', props.armId);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <DetailDialog {...props} title='アーム詳細' src={`${EQUIPMENT_URLS.ARM_DETAIL.URL}/${props.armId}?${URL_PARAMS.DISP_MODE}=${DISP_MODE.POPUP}`}/>
  )
}
